<div class="methodology-wrapper">
  <qai-call-insight-card
    class="methodology-card"
    [heading]="heading"
    [description]="description"
    [headingMode]="'large'"
    [descriptionMode]="'simple'"
    [showLink]="false"
    [objectiveFooterLabel]="objectiveFooterLabel()"
    [applyFadeGradientAtBottom]="metrics().length > 5"
    (viewAllWithObjectiveCount)="onViewAllObjectives()"
  >
    <div qaiSlot="content">
      @if (metrics().length === 0) {
        <p class="no-metrics-message">{{ noMetricsMessage }}</p>
      } @else {
      @for (m of displayedMetrics(); track m.objectiveTitle) {
        <qai-progress-bar
          [label]="m.objectiveTitle"
          labelVariant="bold"
          [value]="m.averageScore"
          [max]="methodologyScaleMax"
          [segments]="methodologyScaleMax"
          [kind]="getKindByPercentage((m.averageScore / methodologyScaleMax) * 100)"
          shape="round"
          size="medium"
          descriptionVariant="value-max"
          style="margin-block-start: var(--spacing-xl)"
        ></qai-progress-bar>
      }
      }
    </div>
  </qai-call-insight-card>

  <app-simulation-detail-list-modal
    #listModal
    [heading]="heading"
    [subheading]="modalSubheading()"
  >
    @for (m of metrics(); track m.objectiveTitle) {
      <qai-progress-bar
        [label]="m.objectiveTitle"
        labelVariant="bold"
        [value]="m.averageScore"
        [max]="methodologyScaleMax"
        [segments]="methodologyScaleMax"
        [kind]="getKindByPercentage((m.averageScore / methodologyScaleMax) * 100)"
        shape="round"
        size="medium"
        descriptionVariant="value-max"
        style="margin-block-start: var(--spacing-xl)"
      ></qai-progress-bar>
    }
  </app-simulation-detail-list-modal>
</div>
